export default `
	guid
	created_at
	updated_at
	type
	title
	body
	is_read
	read_at
	active
`;
